module.exports = {"653131100":"塔什库尔干镇","653131101":"塔吉克阿巴提镇","653131200":"塔什库尔干乡","653131201":"塔合曼乡","653131202":"科克亚尔柯尔克孜族乡","653131203":"提孜那甫乡","653131204":"达布达尔乡","653131205":"马尔洋乡","653131206":"瓦恰乡","653131207":"班迪尔乡","653131208":"库科西鲁格乡","653131210":"大同乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653131.json
// module id = 3258
// module chunks = 0